<template>
    <div class="bg-dark" style="min-height: 100vh">
        <div class="title-h1">Titre</div>
        <div class="title-h2">SubTitle</div>
        <div class="btn">Button</div>
        <div class="btn active icon"><i class="fal fa-save"></i> Button avec du text</div>
        <div class="btn dark">Button</div>
        <div class="btn disabled">Button</div>
        <div class="btn active">Button</div>
        <div class="btn link active">Button</div>
        <div class="btn link small active">Button</div>
        <div class="btn light">Button</div>
        <div class="btn link active"><i class="fal fa-trash"></i></div>
        
        <div class="row middle mb-1">
            <div class="btn link active">Cancel</div>
            <div class="btn icon"><i class="fal fa-save"></i> Save</div>
            <div class="hr-v"></div>
            <div class="btn square"><i class="fal fa-undo"></i></div>
            <div class="btn square disabled"><i class="fal fa-redo"></i></div>
            <div class="hr-v"></div>
            <div class="btn square active">1</div>
            <div class="btn square">2</div>
            <div class="btn square">3</div>
            <div class="btn square"><i class="fal fa-plus"></i></div>
            <div class="btn link active"><i class="fal fa-trash"></i></div>
        </div>
        
        <div class="row">
            <div class="col-2" style="background: red">
                <div class="p-1">
                    texte
                </div>
            </div>
            <div class="col-6" style="background: blue">text 2</div>
            <div class="col-4 bg-default">text 3</div>
        </div>
        <div class="onglets mt-5">
            <div class="onglet" style="border-color:#FFBF60;">
                <div class="icon"><i class="fal fa-images"></i></div>
                <div class="text">
                    Interactive Image : Cazèreaubord dulac
                </div>
                <div class="close"><i class="fal fa-times"></i></div>
            </div>
            <div class="onglet active unsave">
                <div class="icon"><i class="fal fa-images"></i></div>
                <div class="text">
                    * Interactive Image : Cazère au bord du lac
                </div>
                <div class="close"><i class="fal fa-times"></i></div>
            </div>
            <div class="onglet unsave">
                <div class="icon"><i class="fal fa-images"></i></div>
                <div class="text">
                    * Interactive Image : Cazère au bord du lac
                </div>
                <div class="close"><i class="fal fa-times"></i></div>
            </div>
        </div>
        <div class="row">
            <div class="col-2"></div>
            <div class="col-10">
                <div class="volets mt-05">
                    <div class="volet active">
                        <div class="text">Labels</div>
                    </div>
                    <div class="volet">
                        <div class="text">Introduction</div>
                    </div>
                    <div class="volet">
                        <div class="text">Images</div>
                    </div>
                    <div class="volet">
                        <div class="text">Chapters</div>
                    </div>
                    <div class="volet">
                        <div class="text">Other</div>
                    </div>
                </div>
                <div class="row bg-default wrap">
                    <div class="form-input">
                        <label for="">Label</label>
                        <div class="input">
                            <input type="text" value="Valeur">
                            <div class="after">px</div>
                        </div>
                    </div>
                    <div class="form-input">
                        <label for="">Label</label>
                        <div class="input">
                            <input type="text" placeholder="Placeholder">
                        </div>
                    </div>
                    <div class="col-6 pr-05">
                        <div class="form-input">
                            <div class="input">
                                <input type="text" placeholder="Search">
                            </div>
                        </div>
                    </div>
                    <div class="col-6 pl-05">
                        <div class="form-input-list">
                            <div class="input">
                                <input name="browser" placeholder="Filters" @focus="$refs.list2.style.display = 'block'"
                                       @blur="$refs.list2.style.display = 'none'">
                                <div class="after">
                                    <i class="fa fa-angle-down"></i>
                                </div>
                            </div>
                            <ul class="list" ref="list2" style="display: none;">
                                <li>Chrome</li>
                                <li class="select">Safari</li>
                                <li>Internet Explorer</li>
                                <li>FireFox</li>
                            </ul>
                        </div>
                    </div>
                    <div class="form-input">
                        <div class="input">
                            <textarea placeholder="Placeholder"></textarea>
                        </div>
                    </div>
                    <div class="form-input">
                        <label for="">Test</label>
                        <div class="input">
                            <textarea placeholder="Placeholder"></textarea>
                        </div>
                    </div>
                    <div class="hr"></div>
                    <div class="form-input">
                        <label for="">Select</label>
                        <div class="input">
                            <select placeholder="Placeholder">
                                <option value="val1"></option>
                                <option value="val1">Option 1</option>
                                <option value="val1">Option 2</option>
                                <option value="val1">Option 3</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-input-checkbox">
                        <label for="">Select</label>
                        <div class="input">
                            <label class="switch">
                                <input type="checkbox" id="test">
                                <div class="slider"></div>
                            </label>
                            <label for="test">Cocher la case</label>
                        </div>
                    </div>
                    <div class="form-input-list">
                        <label for="">Select</label>
                        <div class="input">
                            <input name="browser" @focus="$refs.list.style.display = 'block'"
                                   @blur="$refs.list.style.display = 'none'">
                            <div class="after">
                                <i class="fa fa-angle-down"></i>
                            </div>
                        </div>
                        <ul class="list" ref="list" style="display: none;">
                            <li>Chrome</li>
                            <li class="select">Safari</li>
                            <li>Internet Explorer</li>
                            <li>FireFox</li>
                        </ul>
                    </div>
                    <div class="hr"></div>
                    <div class="form-image">
                        <label for="">Image</label>
                        <div class="input">
                            <input type="file" style="display:none;" ref="file">
                            <div class="image">
                                <img src="../../assets/images/test.jpg" height="2060" width="2053"/>
                            </div>
                            <div class="upload">
                                <div class="content">
                                    <div class="title-h2">Upload... (20%)</div>
                                    <div class="bar" ref="upload-bar"></div>
                                </div>
                            </div>
                            <div class="buttons">
                                <div class="btn square link light">
                                    <i class="fal fa-trash"></i>
                                </div>
                                <div class="btn square">
                                    <i class="fal fa-edit"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- article -->
                    <div class="hr-title-buttons">
                        <div class="title">Link</div>
                        <div class="buttons">
                            <div class="btn square item">
                                <i class="fal fa-edit"></i>
                            </div>
                        </div>
                    </div>
                    <div class="link-item">
                        <div class="thumbnail">
                            <img src="../../assets/images/test.jpg"/>
                        </div>
                        <div class="content">
                            <div class="top">
                                <div class="type">
                                    <i class="fal fa-text"></i>
                                </div>
                                <div class="title-h1">
                                    Title de l'article
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-eye"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- panno -->
                    <div class="link-item">
                        <div class="thumbnail">
                            <img src="../../assets/images/test.jpg"/>
                        </div>
                        <div class="content">
                            <div class="top">
                                <div class="type">
                                    <i class="fal fa-images"></i>
                                </div>
                                <div class="title-h1">
                                    Le name du panno
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-eye"></i>
                                </div>
                            </div>
                            <div class="title-h2">
                                Intro title du pannp
                            </div>
                        </div>
                    </div>
                    <!-- panno sans img-->
                    <div class="link-item">
                        <div class="thumbnail">
                        </div>
                        <div class="content">
                            <div class="top">
                                <div class="type">
                                    <i class="fal fa-images"></i>
                                </div>
                                <div class="title-h1">
                                    Le name du panno
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-eye"></i>
                                </div>
                            </div>
                            <div class="title-h2">
                                Intro title du pannp
                            </div>
                        </div>
                    </div>
                    <!-- ii -->
                    <div class="link-item">
                        <div class="thumbnail">
                            <img src="../../assets/images/test.jpg"/>
                        </div>
                        <div class="content">
                            <div class="top">
                                <div class="type">
                                    <i class="fal fa-images"></i>
                                </div>
                                <div class="title-h1">
                                    Le name de l'ii
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-eye"></i>
                                </div>
                            </div>
                            <div class="title-h2">
                                Intro title de l'ii
                            </div>
                        </div>
                    </div>
                    <!-- unlinked -->
                    <div class="link-item">
                        <div class="content">
                            <div class="top">
                                <div class="type">
                                    <i class="fal fa-times-circle"></i>
                                </div>
                                <div class="title-h1">
                                    Not linked
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul class="label-items">
                        <li class="label-item">
                            <div class="left">
                                <div class="image">
                                    <i class="fal fa-image"></i>
                                </div>
                                <div class="link">
                                    <div class="text no-link">Not Linked</div>
                                </div>
                            </div>
                            <div class="buttons">
                                <div class="btn square item">
                                    <i class="fal fa-link"></i>
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-trash"></i>
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-edit"></i>
                                </div>
                            </div>
                        </li>
                        <li class="label-item active">
                            <div class="left">
                                <div class="image">
                                    <i class="fal fa-map-marker"></i>
                                </div>
                                <div class="link">
                                    <div class="text linked">
                                        La petite Barrade
                                        <i class="fa fa-images"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="buttons">
                                <div class="btn square item">
                                    <i class="fal fa-link"></i>
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-trash"></i>
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-edit"></i>
                                </div>
                            </div>
                        </li>
                        <li class="label-item">
                            <div class="left">
                                <div class="image">
                                    <img src="../../assets/images/test.jpg" alt="">
                                </div>
                                <div class="link">
                                    <div class="text linked">
                                        La sortie nord
                                        <i class="fa fa-text"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="buttons">
                                <div class="btn square item">
                                    <i class="fal fa-link"></i>
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-trash"></i>
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-edit"></i>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="box">
                        <div class="header">
                            <div class="type">
                                <i class="fal fa-image"></i>
                            </div>
                            <div class="titles">
                                <div class="link no-link">Not linked</div>
                                <div class="type">Overlay</div>
                            </div>
                            <div class="buttons">
                                <div class="btn link active">
                                    Cancel
                                </div>
                                <div class="btn square item">
                                    <i class="fal fa-times"></i>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <div class="form-input">
                                <label for="">Label</label>
                                <div class="input">
                                    <input type="text" value="Valeur">
                                    <div class="after">px</div>
                                </div>
                            </div>
                            <div class="form-input">
                                <label for="">Label</label>
                                <div class="input">
                                    <input type="text" placeholder="Placeholder">
                                </div>
                            </div>
                            <div class="form-image">
                                <label for="">Image</label>
                                <div class="input">
                                    <input type="file" style="display:none;" ref="file">
                                    <div class="image">
                                        <img src="../../assets/images/test.jpg" height="2060" width="2053"/>
                                    </div>
                                    <div class="upload">
                                        <div class="content">
                                            <div class="title-h2">Upload... (20%)</div>
                                            <div class="bar" ref="upload-bar"></div>
                                        </div>
                                    </div>
                                    <div class="buttons">
                                        <div class="btn square link light">
                                            <i class="fal fa-trash"></i>
                                        </div>
                                        <div class="btn square">
                                            <i class="fal fa-edit"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Test"
}
</script>
